// One source for generated logo renditions used by public, auth, and Studio
// chrome. Replace these values when the asset pipeline emits new hashes.
export const BRAND_LOGO = Object.freeze({
  png: '/logo-64.add60d79.png',
  pngSrcSet: '/logo-64.add60d79.png 64w, /logo-128.e651977d.png 128w',
  avifSrcSet: '/logo-64.1f967c7d.avif 64w, /logo-128.6b2ca68b.avif 128w',
})
